import { getReviewFormData } from './get-review-form-data';
import { createReviewCreationData } from './create-review-creation-data';
import { createReview } from './create-review';

export class ReviewSubmissionError extends Error {
    constructor(
        public readonly status: number,
        public readonly reason: string | undefined,
        statusText: string
    ) {
        super(`Error submitting review: [${status}] ${statusText}${reason ? ` (reason: ${reason})` : ''}`);
        this.name = 'ReviewSubmissionError';
    }
}

export type SubmitReviewParams = {
    rootElement: Pick<HTMLElement, 'querySelector' | 'dataset'>;
    multipartUploadActive: boolean;
};
export const submitReview = async ({ rootElement, multipartUploadActive }: SubmitReviewParams) => {
    const reviewFormData = await getReviewFormData({ rootElement });

    const reviewCreationData = createReviewCreationData({ rootElement, reviewFormData });

    const postResponse = await createReview(reviewCreationData, reviewFormData.images, multipartUploadActive);

    if (postResponse.status !== 201) {
        if (!multipartUploadActive) {
            throw new Error(`Error submitting review: [${postResponse.status}] ${postResponse.statusText}`);
        }
        throw new ReviewSubmissionError(postResponse.status, await readRejectionReason(postResponse), postResponse.statusText);
    }
};

const readRejectionReason = async (response: Response): Promise<string | undefined> => {
    try {
        const body: unknown = await response.json();
        if (typeof body === 'object' && body !== null && 'reason' in body && typeof body.reason === 'string') {
            return body.reason;
        }
    } catch {
        throw new Error('Failed to read rejection reason');
    }
    return undefined;
};
